<template>
  <div class="switch-table-stat-type-container" :class="{ center: align === 'center', right: align === 'right' }">
    <el-dropdown @command="handleCommand" trigger="click">
      <span class="el-dropdown-link">
        {{ currentLabel }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in options" :command="item.value" :key="item.value">
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'switch-table-stat-type',
  props: {
    value: {
      required: true,
    },
    align: {
      type: String,
      default: 'center',
    },
  },
  watch: {
    value() {
      this.val = this.value;
    },
  },
  data() {
    return {
      val: this.value,
      options: [
        { label: '合计', value: 'valSum' },
        { label: '均值', value: 'valAvg' },
      ],
    };
  },
  computed: {
    currentLabel() {
      const findItem = this.options.find(item => item.value === this.val);
      if (findItem) {
        return findItem.label;
      }
      return '未知';
    },
  },
  methods: {
    handleCommand(cmd) {
      this.val = cmd;
      this.$emit('input', this.val);
      this.$emit('change', this.val);
    },
  },
};
</script>

<style lang="less" scoped>
.switch-table-stat-type-container {
  position: relative;
  line-height: inherit;
  display: flex;
  align-items: center;

  &.center {
    justify-content: center;
  }

  &.right {
    justify-content: flex-end;
  }

  div {
    line-height: inherit;
  }
}
</style>
